import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs/Observable";
import { User, IUser, IUserListModel, IGrant, IGrantItem, IChangePassword, IUserDrawingPoint, UserDrawingPointModel, IForceChangePassword, UserModel, UserDrawingPointsModel, ChangePasswordModel, WelcomeModel } from "./user";
import { AppCommonService } from "../appcommon.service";
import { AuthService } from "../auth.service";
import { GlobalService } from "../global.service";
import { Router } from "@angular/router";
import { ApiEndPoints } from "../api.endpoints";
import { forEach } from "@angular/router/src/utils/collection";

@Injectable()
export class UserService extends GlobalService {

  constructor(
    private http: Http,
    private cookieService: CookieService,
    private appCommonService: AppCommonService,
    private authService: AuthService,
    private router: Router
  ) {
    super(http, router);
    this.authServiceRef = this.authService;
  }

  getUserGrants(): IGrant[] {
    let grantsList: IGrantItem[] = [];
    grantsList.push(<IGrantItem>{ name: "View Drawings", value: "DRAWINGS" });
    grantsList.push(<IGrantItem>{ name: "View Live Cards", value: "LIVE_CARDS" });
    grantsList.push(<IGrantItem>{ name: "View Dead Cards", value: "DEAD_CARDS" });
    grantsList.push(<IGrantItem>{ name: "View Invoices", value: "INVOICES" });
    grantsList.push(<IGrantItem>{ name: "View Statements", value: "STATEMENTS" });
    grantsList.push(<IGrantItem>{ name: "Stop Cards", value: "STOP_CARDS" });
    grantsList.push(<IGrantItem>{ name: "Request New Cards", value: "REQUEST_CARDS" });
    let grants: IGrant[] = [];
    for (let grantItem of grantsList) {
      grants.push(<IGrant>{ avail: false, name: grantItem.name, value: grantItem.value });
    }
    return grants;
  }

  getUsersList(): Observable<IUserListModel[]> {
    //debugger;
    if (ApiEndPoints.UseDirectEndPoint) {
      let token = this.authService.getToken();
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.UserListEndPoint.replace('{companyId}', token.companyId);
      return this.http.get(url, options)
        .map(data => <IUserListModel[]>data.json())
        .catch(this.handleError);
    }
    else {
      //debugger
      let token = this.authService.getToken();
      let model = new UserModel();
      //model.EndPointURL = ApiEndPoints.UserListEndPoint;
      model.CompanyId = token.companyId;
      model.Token = token.access_token;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.UserListEndPointServer;
      return this.http.post(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }    
  }

  getUser(id: string): Observable<IUser> {
    //debugger;
    if (id === "0") {
      return Observable.of(this.initializeUser());
    };

    if (ApiEndPoints.UseDirectEndPoint) {
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.UserEndPoint.replace('{userId}', id);
      return this.http.get(url, options)
        .map(this.extractData)
        // .do(data => console.log('getProduct: ' + JSON.stringify(data)))
        .catch(this.handleError);
    }
    else {            
      let token = this.authService.getToken();
      let model = new UserModel();
      //model.EndPointURL = ApiEndPoints.UserEndPointV2;
      model.UserId = id;
      model.Token = token.access_token;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.UserEndPointServer;
      return this.http.post(callURL, body, options)
        .map((response: Response) => <any>response.json())        
        .catch(this.handleError);
    }    
  }

  saveUser(user: IUser): Observable<IUser> {
    if (user.id === "0") {
      return this.createUser(user);
    }
    return this.updateUser(user);
  }

  private createUser(user: IUser): Observable<IUser> {
    if (ApiEndPoints.UseDirectEndPoint) {
      user.id = undefined;
      user.forcePasswordChange = true;
      user.displayWelcomeFlag = true;
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.UserCreateEndPoint;
      return this.http.post(url, user, options)
        // .do(data => console.log('createUser: ' + JSON.stringify(data)))
        .catch(this.handleError);
    }
    else {
      let token = this.authService.getToken();
      let model = new UserModel();
      //model.EndPointURL = ApiEndPoints.UserCreateEndPoint;
      model.Token = token.access_token;
      user.id = undefined;
      user.forcePasswordChange = true;
      user.displayWelcomeFlag = true;
      model.User = user;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.UserCreateEndPointServer;
      return this.http.post(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }
  }

  private updateUser(user: IUser): Observable<IUser> {
    //debugger
    if (ApiEndPoints.UseDirectEndPoint) {
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.UserUpdateEndPoint.replace('{userId}', user.id);
      //console.log(JSON.stringify(user));
      return this.http.put(url, user, options)
        // .do(data => console.log('updateUser: ' + JSON.stringify(data)))
        .catch(this.handleError);
    }
    else {
      let token = this.authService.getToken();
      let model = new UserModel();
      //model.EndPointURL = ApiEndPoints.UserUpdateEndPoint;
      model.Token = token.access_token;      
      model.User = user;
      model.UserId = user.id;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.UserUpdateEndPointServer;
      return this.http.put(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }    
  }

  public updateWelcomeMessage(id: string): Observable<Response> {
    //debugger
    if (ApiEndPoints.UseDirectEndPoint) {
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.WelcomeMessage.replace('{userId}', id) + "?displayWelcome=false";
      return this.http.post(url,'', options)
        // .do(data => console.log('updateUser: ' + JSON.stringify(data)))
        .catch(this.handleError);
    }
    else {
      let token = this.authService.getToken();
        let model = new WelcomeModel();
        model.userId = id;
      //model.EndPointURL = ApiEndPoints.WelcomeMessage.replace('{userId}', id) + "?displayWelcome=false";
      model.Token = token.access_token;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.WelcomeMessageServer;
      return this.http.post(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }
  }

  deleteUser(id: string): Observable<Response> {
    if (ApiEndPoints.UseDirectEndPoint) {
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.UserDeleteEndPoint.replace('{userId}', id);
      return this.http.delete(url, options)
        .do(data => console.log('deleteUser: ' + JSON.stringify(data)))
        .catch(this.handleError);
    }
    else {
      let token = this.authService.getToken();
      let model = new UserModel();
     // model.EndPointURL = ApiEndPoints.UserDeleteEndPoint;
      model.Token = token.access_token;      
      model.UserId = id;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.UserDeleteEndPointServer;
      return this.http.post(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }    
  }

  initializeUser(): IUser {
    // Return an initialized object
    return {
      title: null,
      firstName: null,
      lastName: null,
      email: null,
      telephone: null,
      mobile: null,
      fax: null,
      jobTitle: null,
      address1: null,
      address2: null,
      town: null,
      county: null,
      postcode: null,
      displayWelcomeFlag: false,
      forcePasswordChange: false,
      grants: [],
      id: "0",
      companyId: null,
      username: null,
      password: null,
      role: null,
      companyPrimaryContact: null
    };
  }

  updateUserPassword(changePassword: IChangePassword): Observable<IChangePassword> {
    if (ApiEndPoints.UseDirectEndPoint) {
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.UserChangePasswordEndPoint.replace('{userId}', changePassword.id);
      return this.http.post(url, changePassword, options)
        // .do(data => console.log('createUser: ' + JSON.stringify(data)))
        .catch(this.handleError);
    }
    else {
      let token = this.authService.getToken();
      let model = new ChangePasswordModel();
      model.EndPointURL = ApiEndPoints.UserChangePasswordEndPoint;
      model.Token = token.access_token;
      model.ChangePassword = changePassword;
      model.UserId = changePassword.id;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.UserChangePasswordEndPointServer;
      return this.http.post(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }    
  }

  randomPassword(): string {
    // var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
    // var pass = "";        
    // for (var x = 0; x < 8; x++) {
    //     var i = Math.floor(Math.random() * chars.length);
    //     pass += chars.charAt(i);
    // }
    // return pass;
    var pass = "";
    var passwordLength = 8;
    var numberChars = "0123456789";
    var upperChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var lowerChars = "abcdefghijklmnopqrstuvwxyz";
    var specialChars = "@#$%";
    var allChars = numberChars + upperChars + lowerChars + specialChars;
    var randPasswordArray = Array(passwordLength);
    randPasswordArray[0] = numberChars;
    randPasswordArray[1] = upperChars;
    randPasswordArray[2] = lowerChars;
    randPasswordArray[3] = specialChars;
    randPasswordArray = randPasswordArray.fill(allChars, 4);
    pass = this.shuffleArray(randPasswordArray.map(function (x) { return x[Math.floor(Math.random() * x.length)] })).join('');
    return pass;
  }

  shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  }

  randomUserName() {
    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4()).toLowerCase();
  }

  getUserDrawingPointAccess(id: string): Observable<IUserDrawingPoint[]> {
    if (ApiEndPoints.UseDirectEndPoint) {
      let token = this.authService.getToken();
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.UserDrawingPointAccessEndPoint.replace('{userId}', id);
      return this.http.get(url, options)
        .map(data => <IUserDrawingPoint[]>data.json())
        .catch(this.handleError);
    }
    else {
      let token = this.authService.getToken();
      let model = new UserDrawingPointsModel();
     // model.EndPointURL = ApiEndPoints.UserDrawingPointAccessEndPoint;
      model.UserId = id;
      model.Token = token.access_token;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.UserDrawingPointAccessEndPointServer;
      return this.http.post(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }    
  }

  saveUserDrawingPointAccess(userDrawingPointModel: UserDrawingPointModel): Observable<UserDrawingPointModel> {
    if (ApiEndPoints.UseDirectEndPoint) {
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.UserDrawingPointAccessEndPoint.replace('{userId}', userDrawingPointModel.id);
      return this.http.post(url, userDrawingPointModel.accesspoints, options)
        // .do(data => console.log('updateUser: ' + JSON.stringify(data)))
        .catch(this.handleError);
    }
    else {
      let token = this.authService.getToken();
      let model = new UserDrawingPointsModel();
     // model.EndPointURL = ApiEndPoints.UserDrawingPointAccessEndPoint;
      model.Token = token.access_token;
      model.UserDrawingPoints = userDrawingPointModel.accesspoints;
      model.UserId = userDrawingPointModel.id;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.UserDrawingPointAccessEndPointSaveServer;
      return this.http.post(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }    
  }

  updateUserForcePassword(changePassword: IChangePassword): Observable<IChangePassword> {
    if (ApiEndPoints.UseDirectEndPoint) {
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.UserChangePasswordEndPoint.replace('{userId}', changePassword.id);
      return this.http.post(url, changePassword, options)
        // .do(data => console.log('createUser: ' + JSON.stringify(data)))
        .catch(this.handleError);
    } else {
      let token = this.authService.getToken();
      let model = new ChangePasswordModel();
      model.EndPointURL = ApiEndPoints.UserChangePasswordEndPoint;
      model.Token = token.access_token;
      model.ChangePassword = changePassword;
      model.UserId = changePassword.id;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.UserChangePasswordEndPointServer;
      return this.http.post(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }    
  }
}



// WEBPACK FOOTER //
// ./src/app/users/user.service.ts